<template>
  <AppHeaderDropdown no-caret>
    <template slot="header">
      <img :src="avatar"
        width="35"
        height="35"
        class="img-avatar"
        alt="admin@bootstrapmaster.com" />
        <p style="font-size: 12px; margin-bottom: 0">Meu Perfil</p>

    </template>
    <template slot="dropdown">
      <b-dropdown-item @click="navegarAdminConferencia" v-if="is_admin_conferencia || is_admin_local"><i class="fa fa-cog"/>Área Administrativa - Conferências</b-dropdown-item>
      <b-dropdown-item @click="navegarAdminGeral" v-if="is_admin_geral"><i class="fa fa-cog"/>Área Administrativa - Geral</b-dropdown-item>
      <b-dropdown-divider/>
      <b-dropdown-item @click="logout"><i class="fa fa-sign-out"/>Sair</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import Vue from 'vue'
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import SessionStorage from '@/services/session-storage'
import { mapState } from 'vuex'

export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  created () {
    if (this.avatar === 'null') {
      this.avatar = 'https://upload.wikimedia.org/wikipedia/commons/1/1e/Default-avatar.jpg'
    }
    this.is_admin_geral = SessionStorage.get('is_admin_geral') === 'true' ? true : false
    this.is_admin_conferencia = SessionStorage.get('is_admin_conferencia') === 'true' ? true : false
    this.is_admin_local = SessionStorage.get('is_admin_local') === 'true' ? true : false

  },
  data: () => {
    return {
      avatar: SessionStorage.get('avatar'),
      is_admin_geral: false,
      is_admin_conferencia: false
    }
  },
  computed: {
    ...mapState({
      usuario: state => state.usuario.usuario,
      conferencia: state => state.conferencia.conferencia
    })
  },
  methods: {
    navegarAdminGeral () {
      this.navigate('/administrativa')
    },
    navegarAdminConferencia () {
      this.$store.dispatch('setModalConferencia', {modal: true})
    },
    navigate (route) {
      this.$router.push(route)
    },
    logout () {
      this.$store.dispatch('setConferencia', null)
      this.$store.dispatch('setConfigurarConferencia', null)
      sessionStorage.clear()
      location.href = process.env.URL_LOGOUT
      // this.navigate('/externa')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/templates/containers/DefaultHeaderDropdownAccnt.vue